import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconFog: React.FC<BaseWeatherIconProps> = ({ className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M83.3327 26.1445H16.666V32.0779H83.3327V26.1445Z"
        fill="#D2E0FF"
      />
      <path
        d="M72.2216 39.9333H16.666V46.0778H72.2216V39.9333Z"
        fill="#D2E0FF"
      />
      <path
        d="M83.3331 53.9224H38.8887V59.8557H83.3331V53.9224Z"
        fill="#D2E0FF"
      />
      <path
        d="M72.2216 67.7112H16.666V73.8556H72.2216V67.7112Z"
        fill="#D2E0FF"
      />
    </svg>
  )
}

export default WeatherIconFog
